var sizes = {
  xs2: '2px',
  xs: '4px',
  s: '8px',
  m: '12px',
  l: '16px',
  xl: '24px',
  xl2: '32px',
  xl3: '48px',
  xl4: '64px'
};
var getSize = function getSize(size) {
  return sizes[size];
};

export { getSize };
//# sourceMappingURL=getSize.js.map
